import { useState } from 'react';

const faqItems = [
  {
    question: 'What is the Vigorbuy Spreadsheet?',
    answer: 'The Vigorbuy Spreadsheet is an organized directory of verified product links, shopping guides, QC tips, and updated collections. It helps shoppers discover products across multiple categories — from shoes and hoodies to bags and accessories — all in one convenient resource. Our spreadsheet is updated weekly with fresh product links and the latest buying advice.',
  },
  {
    question: 'Is the Vigorbuy Spreadsheet safe to use?',
    answer: 'Yes. The Vigorbuy Spreadsheet is an independent informational resource designed to improve your shopping experience. We provide verified product links, detailed quality check guides, and safety tips. Always review product details, compare information, and check quality before ordering. We recommend reading our complete safety guide for the best experience.',
  },
  {
    question: 'How often is the Vigorbuy Spreadsheet updated?',
    answer: 'The Vigorbuy Spreadsheet is updated weekly with new products, refreshed links, and the latest shopping guides. Our team regularly verifies product availability and adds new categories to ensure you always have access to the most current information. Bookmark this page to stay updated with the latest vigorbuy spreadsheet releases.',
  },
  {
    question: 'Is the Vigorbuy Spreadsheet free?',
    answer: 'Absolutely. The Vigorbuy Spreadsheet is completely free to access. There is no registration required, no subscription fees, and no hidden costs. Simply browse our organized categories, use the guides, and click through to Kaspreadsheet to start shopping. We believe quality shopping resources should be accessible to everyone.',
  },
  {
    question: 'What categories are available in the Vigorbuy Spreadsheet?',
    answer: 'The updated vigorbuy spreadsheet covers 14 main categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff. Each category contains hundreds to thousands of verified product links organized for easy browsing.',
  },
  {
    question: 'How do I use the Vigorbuy Spreadsheet effectively?',
    answer: 'Start by browsing the category that interests you. Use the dropdown menu to navigate between categories. Read our buying guides and QC tips for each product type. Compare product details across listings. When ready, click through to Kaspreadsheet to view full product details and make your purchase. For detailed instructions, check our complete guide page.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-4">
            Got Questions?
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-foreground-500 text-base max-w-lg mx-auto">
            Everything you need to know about the <strong className="font-semibold text-foreground-800">best vigorbuy spreadsheet</strong> and how to use it.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-150"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}